import { calculateFundsData } from '../../hooks/useFundsCalculator';

/**
 * Set calculated funds data in the global store
 * @param {Object} calculatedFunds - The processed funds data
 */
export const setCalculatedFunds = (calculatedFunds) => {
  return {
    type: 'SET_CALCULATED_FUNDS',
    payload: calculatedFunds
  };
};

/**
 * Update calculated funds based on the latest data
 * This can be used when we need to force a recalculation
 */
export const updateCalculatedFunds = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const availableFunds = state.funds.fundsViewV2;
    const positionMetrics = state.portfolio.positionMetrics || {};
    
    // Skip if no funds data available
    if (!availableFunds) return;
    
    // Use the common calculation function from useFundsCalculator
    const calculatedFunds = calculateFundsData(availableFunds, positionMetrics);
    
    // Dispatch the calculated data
    dispatch(setCalculatedFunds(calculatedFunds));
  };
};